import { api } from "../../axios";
import { PropertyAPI } from "../../axios";

export const actions = {
    //Property Building
    GetBuilding(context, data){
        return PropertyAPI.get(`Building/Campus/${data}`);
    },
    GetSingleBuilding(context, data){
        return PropertyAPI.get(`Building/${data}`);
    },
    UpdateBuilding(context, data){
        return PropertyAPI.put(`Building/${data.id}`, data);
    },
    DeleteBuilding(context, data){
        return PropertyAPI.delete(`Building/${data}`);
    },
    CreateBuilding(context, data){
        return PropertyAPI.post(`Building/Create`, data);
    },
    TransferBuilding(context, data){
        return PropertyAPI.post(`Building/Transfer/${data.id}`, data.arr);
    },

    //Property Location
    GetPropertyLocation(context, data){
        return api.get(`PropertyLocation/Building/${data}`);
    },
    GetSinglePropertyLocation(context, data){
        return api.get(`PropertyLocation/${data}`);
    },
    GetPropertyWarehouse(context, data){
        return api.get(`PropertyLocation/Warehouse/${data}`);
    },
    UpdatePropertyLocation(context, data){
        return api.put(`PropertyLocation/${data.id}`, data);
    },
    DeletePropertyLocation(context, data){
        return api.delete(`PropertyLocation/${data}`);
    },
    CreatePropertyLocation(context, data){
        return api.post(`PropertyLocation/Create`, data);
    },

}